import React, { useState, useRef } from "react";
import SSPCommonModal from "../../CommonComponents/SSPCommonModal/SSPCommonModal";
import { PageBar, SSPCommonButton, } from "../../CommonComponents";
import Grid from "@mui/material/Grid";
import { Box, Card, CardContent, CardHeader, Divider, Typography, TextField, CircularProgress, } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import { post } from "../../services";
import Cookies from "js-cookie";
import styles from "./Styles";
import Loader from "../../CommonComponents/Loader";
import axios from "axios";

const base = "https://";

const AssetTagging = ({ token }) => {
    const id = Cookies.get("ssp_id");
    const [loading, setLoading] = useState(false);
    const [loc, setLoc] = useState("");
    const [modalOpener, setmodalOpener] = useState(false);
    const [message, setmessage] = useState("");
    const [locationCode, setLocationCode] = useState("");
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);

    const handleDownloadAssetMaster = async (type) => {
        setLoading(true);
        let payload = {
            type: type,
            source: "SSP"
        };

        let response = await post(
            base + "bjkhbsrllhuogrxobvufau4rxy0qvvxu.lambda-url.ap-south-1.on.aws/download_excel_data",
            payload,
            true,
            false
        );

        if (response?.status === "success") {
            window.open(response?.url);
            setLoading(false);
        } else {
            setmessage(response?.message);
            setmodalOpener(true);
            setLoading(false);
        }
    };

    const handleUpload = async () => {
        if (selectedFile) {
            if (selectedFile instanceof File) {
                const fileExtension = selectedFile.name.split('.').pop().toLowerCase();
                if (fileExtension !== "xlsx") {
                    setmessage("Only .xlsx files are allowed.");
                    setmodalOpener(true);
                    return;
                }
            }
            setLoading(true)
            let filenameWithTimestamp;
            if (selectedFile instanceof File) {
                const timestamp = new Date()
                    .toISOString()
                    .replace(/[-:.]/g, "")
                    .slice(0, 15);
                filenameWithTimestamp = `${selectedFile?.name
                    .split(".")
                    .slice(0, -1)
                    .join(".")}_${timestamp}.${selectedFile?.name?.split(".")?.pop()}`;
            } else {
                filenameWithTimestamp = selectedFile;
            }
            let presignedUrlResponse = await post(
                base +
                "bjkhbsrllhuogrxobvufau4rxy0qvvxu.lambda-url.ap-south-1.on.aws/assets_post_url",
                {
                    object_name: filenameWithTimestamp?.replace(/[()]/g, ""),
                    source: "SSP"
                },
                true,
                false
            );
            if (presignedUrlResponse?.status === 'error') {
                setmessage(presignedUrlResponse?.data?.message);
                setmodalOpener(true);
                return
            }
            console.log('presignedUrlResponse===>', presignedUrlResponse)

            const presignedUrl = presignedUrlResponse;

            if (!presignedUrl) {
                console.error("Presigned URL is not valid");
                return;
            }
            if (selectedFile instanceof File) {
                const fileUploaded = await uploadFileWithPresignedUrl(
                    selectedFile,
                    presignedUrl
                );
                if (fileUploaded) {
                    let response = await post(
                        base + "bjkhbsrllhuogrxobvufau4rxy0qvvxu.lambda-url.ap-south-1.on.aws/save_asset_details",
                        {
                            object_name: presignedUrl.fields.key,
                            source: "SSP"
                        },
                        true,
                        false
                    );
                    if (response?.status === "success" || response?.status === "Success") {

                        setLoading(false)
                        setmessage(response?.message || "File Uploaded");
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);

                    } else if (response?.status === "Error" || response?.status === "error") {
                        setLoading(false)

                        setmessage(response?.message);
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);

                    }

                    else {
                        setLoading(false)

                        setmessage(response?.body?.message);
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);

                    }

                }

                if (!fileUploaded) {
                    if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                    }
                    setLoading(false)
                    setSelectedFile(null);

                    console.error("File upload failed");
                    return;
                }
            }

        } else {
            setLoading(false)

            setmessage("Please select file to upload");
            setmodalOpener(true);
        }
    }
    const uploadFileWithPresignedUrl = async (filetoUpload, generatedUrl) => {
        try {
            const fileUploadData = new FormData();
            Object.keys(generatedUrl.fields).forEach((key) => {
                fileUploadData.append(key, generatedUrl.fields[key]);
            });
            fileUploadData.append("file", filetoUpload);
            const fileUploaded = await uploadFile(generatedUrl.url, fileUploadData);
            if (fileUploaded) {
                return true;
            } else {
                console.error("File upload failed");
                return false;
            }
        } catch (error) {
            console.error("Error during file upload:", error);
            throw error;
        }
    };

    const uploadFile = async (url, formData) => {
        try {
            const response = await axios.post(url, formData);

            if (response.status === 204) {
                console.log("File upload successful with status 204");
                return true;
            }

            if (response.status >= 200 && response.status < 300) {
                console.log("File upload successful");
                return true;
            } else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        } catch (error) {
            console.error("Error during file upload:", error);
            throw error;
        }
    };



    return (
        <Box sx={styles.assetMasterContainer} >
            <Loader loading={loading} />
            <PageBar
                text="Asset Tagging : Physical verification exercise"
            />
            <Card sx={styles.assetmasterCard} >
                <CardHeader
                    p={2}
                    sx={styles.assetmasterCardHeader}
                    title={" Download Physical verification data"}
                    titleTypographyProps={{
                        sx: { fontSize: "16px", fontWeight: "600", lineHeight: "16px", color: "#0160F1", },
                    }}
                />
                <Divider />
                <CardContent sx={styles.assetmasterCardContent} >
                    <Grid container spacing={2} >

                        <Grid item xs={12} sm={6} md={4} lg={3.5} xl={4} sx={{ ...styles.dwnldAssetMasterbttnStyle }} >
                            <SSPCommonButton
                                btnText="Download Physical verification assets"
                                btnFunction={() => {
                                    handleDownloadAssetMaster('PV')
                                }}
                            />

                        </Grid>
                        <Grid item xs={12} sm={5} md={4} lg={3} sx={{ ...styles.dwnldAssetMasterStyle, alignItems: 'flex-end', justifyContent: 'flex-end' }} >
                            <SSPCommonButton
                                btnText={"Download tagged assets at store"}
                                btnFunction={() => handleDownloadAssetMaster('TA')}
                            />
                        </Grid>

                    </Grid>
                </CardContent>
                <CardHeader
                    p={2}
                    sx={styles.assetmasterCardHeader}
                    title={" Upload file to confirm physical verification of assets"}
                    titleTypographyProps={{
                        sx: { fontSize: "16px", fontWeight: "600", lineHeight: "16px", color: "#0160F1", },
                    }}
                />
                <Divider />
                <CardContent sx={styles.assetmasterCardContent} >
                    <Grid container spacing={2} >
                        <Grid item xs={12} sm={6} md={6} lg={4} xl={4} sx={styles.locContainer} >
                            <Box p={2} sx={styles.fileStyle} >
                                <Box p={1} sx={styles.fileInputStyle} >
                                    <input
                                        type="file"

                                        ref={fileInputRef}
                                        multiple={false}
                                        onChange={(e) => {
                                            setSelectedFile(e.target.files[0]);
                                        }}

                                    />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3.5} xl={4} sx={{ ...styles.dwnldAssetMasterbttnStyle }} >
                            <SSPCommonButton
                                btnText="Upload physical verification of assets"
                                btnFunction={() => {
                                    handleUpload()
                                }}
                            />

                        </Grid>

                    </Grid>

                </CardContent>

            </Card>


            {modalOpener && (
                <SSPCommonModal
                    open={modalOpener}
                    handleOpenClose={setmodalOpener}
                    message={message}
                />
            )}

        </Box>
    )
}

export default AssetTagging

